var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-module"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.content.intro_headline))]),_c('span',{staticClass:"copy"},[_vm._v(_vm._s(_vm.content.intro_copy))])])}
var staticRenderFns = []

export { render, staticRenderFns }